var PasswordProtect = {
    term_id: "",

    load: function() {        
        var thisModule = this;
        thisModule.destination = "category-page";
     
        setTimeout(function() {
            thisModule.eventhandlers();
        }, 300);
    },

    eventhandlers: function() {
        var thisModule = this;

        jQuery("#helpie-password-modal.small.ui.modal").modal({
            // blurring: true,
            transition: "fade up",
            observeChanges: true,
            onApprove: function(event) {
                console.log("password-modal onApprove");
                thisModule.passwordSubmit();
                return false;
            }
        });

        jQuery(".pauple_helpie.ui.modal").modal("hide");

        /*  
            When  jQuery('.small.ui.modal').modal({ }); is not working .
            Note: Click events are not triggering in Avada Theme
        */
        jQuery("#helpie-password-modal .actions .positive").click(function() {
            thisModule.passwordSubmit();
        });

        jQuery("#helpie-password-modal.modal .actions .deny").click(function() {
            console.log("deny");
            jQuery(".modal-backdrop.in").hide();
            jQuery(".pauple_helpie.ui.modal").hide();
        });    
        
        /* Single and Category Page */
        
         jQuery(".helpie-enter-password").click(function() {
            thisModule.term_id = jQuery(this).attr("data-term-id");

            if (jQuery(this).data("origin")) {
                thisModule.origin_location = jQuery(this).data("origin");
            }

            if (jQuery(this).data("post-id")) {
                thisModule.post_id = jQuery(this).data("post-id");
            }

            thisModule.showPasswordModal();
        });        

        /* Search Results Page */

        jQuery(".helpie-search-listing .helpie-element.protected").click(
            function() {
                thisModule.post_id = jQuery(this).data("post-id");
                thisModule.term_id = jQuery(this).data("term-id");

                console.log("term-id: " + thisModule.term_id);
                thisModule.destination = "single-page";

                thisModule.origin_location = "search-page";
                thisModule.onProtectedClick(this);
            }
        );
                   
        /* Table Of Contents */

        jQuery(".helpie-toc div.protected").click(function() {
            thisModule.onProtectedClick(this);
        });

        /* Article Listing */
        
        jQuery(".helpie-articles-listing .helpie-element.protected").click(
            function() {
                thisModule.post_id = jQuery(this).data("post-id");
                thisModule.term_id = jQuery(this).data("term-id");
                thisModule.destination = "single-page";
                thisModule.onProtectedClick(this);
            }
        );

        /* Category Listing elements with term-id-x should be clicked */
        
        jQuery(
            "#helpie-categories-section-boxed .helpie-category-listing .helpie-element.protected"
        ).click(function() {
            thisModule.onProtectedClick(this);
        });

        jQuery(
            "#helpie-categories-section-boxed1 .helpie-category-listing .helpie-element.protected"
        ).click(function() {
            thisModule.onProtectedClick(this);
        });

        jQuery(
            "#helpie-categories-section-modern .helpie-category-listing .helpie-element.protected"
        ).click(function() {
            thisModule.onProtectedClick(this);
        });

        // onClick Event for each article inside in Modern and Boxed1 Category Listing 
        jQuery(
            ".helpie-category-listing .helpie-element.protected .article-preview-list li"
        ).click(function (e) {
            
            if (jQuery(this).data().article) {             
                thisModule.post_id = jQuery(this).data("post-id");
                thisModule.term_id = jQuery(this).data("term-id");
                thisModule.destination = "single-page";    
            }
            
            thisModule.onProtectedClick(this);

            e.stopImmediatePropagation();
        });   
    },

    onProtectedClick: function(element) {
        console.log("onProtectedClick");
        var thisView = this;
        var classes = jQuery(element)
            .attr("class")
            .split(" ");

        if (jQuery(element).data("origin")) {
            thisView.origin_location = jQuery(element).data("origin");
        }

        for (var ii = 0; ii < classes.length; ii++) {
            var className = classes[ii];
            console.log("className: " + className);
            if (className.match("term-id")) {
                thisView.term_id = className.replace("term-id-", "");
            }
        }

        console.log("termID: " + thisView.term_id);
        console.log("my_ajax_object.ajax_url: " + my_ajax_object.ajax_url);
        var nonce = helpieKBFrontEndNonce;
        var data = {
            action: "helpie_check_transient_password_action",
            nonce: nonce,
            term_id: thisView.term_id
        };

        jQuery.post(my_ajax_object.ajax_url, data, function(response) {
            var ajaxResponse = JSON.parse(response);
            console.log(
                "helpie_check_transient_password ajaxResponse: " + ajaxResponse
            );
            if (
                ajaxResponse &&
                ajaxResponse != 0 &&
                ajaxResponse.match("http")
            ) {
                window.location.assign(ajaxResponse);
            } else {
                thisView.showPasswordModal();
            }
        });
    },

    showPasswordModal: function() {
        console.log("showPasswordModal");
        jQuery(".small.ui.modal").modal("show");

        /*
         * Fix for Avada Theme:
         * where modal does not show when you open it for the second time after closing
         */
        if (jQuery(".small.ui.modal").is(":visible")) {
        } else {
            jQuery(".small.ui.modal").show();
        }
    },

    passwordSubmit: function() {        
        var thisModule = this;    
        var origin_location,
            post_id,
            data,
            nonce,
            input;
        
        nonce = helpieKBFrontEndNonce;
        input = jQuery(".pauple_helpie.ui.modal input[type=password]").val();

        if (thisModule.origin_location) {
            origin_location = thisModule.origin_location;
        } else {
            origin_location = "term_page";
        }        
        if (thisModule.post_id) {
            post_id = thisModule.post_id;
        }

        console.log("term_id: " + this.term_id);
        data = {
            action: "helpie_validate_password_input",
            nonce: nonce,
            term_id: this.term_id,
            password_input: input,
            origin_location: origin_location,
            post_id: post_id,
            destination: thisModule.destination
        };

        // console.log("input: " + input);
        // console.log("term_id: " + this.term_id);

        jQuery.post(my_ajax_object.ajax_url, data, function(response) {
            var ajaxResponse = JSON.parse(response);
            console.log("ajaxResponse: " + ajaxResponse);
            if (ajaxResponse == 0) {
                thisModule.wrongPassword();
            } else {
                if (ajaxResponse.match("http")) {
                    thisModule.correctPassword(ajaxResponse);
                } else {
                    thisModule.wrongPassword();
                }
            }
        });
    },       

    correctPassword: function(ajaxResponse) {
        var input_selector = ".pauple_helpie.ui.modal input[type=password]";
        jQuery(input_selector).css("border-color", "#75d69c");
        if (jQuery(".pauple_helpie.ui.modal .password-status")) {
            jQuery(".pauple_helpie.ui.modal .password-status").remove();
        }

        jQuery(input_selector).after(
            "<span class='password-status correct'>Verified. Redirecting you now <img class='redirect-gif' src='" +
                helpieGlobal.plugin_url +
                "includes/asset-files/images/redirecting.gif' /></span>"
        );
        window.location.assign(ajaxResponse);
    },

    wrongPassword: function() {
        var input_selector = ".pauple_helpie.ui.modal input[type=password]";
        jQuery(input_selector).css("border-color", "#fe6c61");
        if (jQuery(".pauple_helpie.ui.modal .password-status")) {
            jQuery(".pauple_helpie.ui.modal .password-status").remove();
        }

        jQuery(input_selector).after(
            "<span class='password-status wrong'>Wrong Password</span>"
        );
    }    
};

module.exports = PasswordProtect;
